'use client';

import cx from 'classnames';
import { Wrapper, Status } from '@googlemaps/react-wrapper';
import { Libraries } from '@googlemaps/js-api-loader';
import { useParams } from 'next/navigation';
import { CatSkeleton } from 'blocks-nextjs/blocks-react/components/Skeleton';
import styles from './google-maps-loader.module.scss';

const LIBRARIES = ['marker'];

export const GoogleMapsLoader = ({ children, useSmallLoader = true }) => {
  // TODO - Input Validation - Ensure that all values used from params are allowed values:
  // lang should always be a two-digit string without numbers or special characters (like 'es').
  const params = useParams();

  const skeletonSize = useSmallLoader ? 'xl' : 'xxl';

  const render = (status: Status) => {
    switch (status) {
      case Status.LOADING:
        return (
          <div
            className={cx(
              'mb-3',
              styles['google-maps-loader-skeleton-container'],
              {
                [styles['google-maps-loader-skeleton-small-height']]:
                  useSmallLoader
              }
            )}
          >
            <CatSkeleton size={skeletonSize} />
          </div>
        );
      case Status.FAILURE:
        return null;
      case Status.SUCCESS:
        return children;
    }
  };

  return (
    <Wrapper
      //using client parameter to have map work while we don't have api key
      apiKey=""
      client="gme-caterpillarinc"
      language={params?.lang as string}
      libraries={LIBRARIES as Libraries}
      render={render}
    />
  );
};
